import { useNavigate } from 'react-router-dom';
import DetailScreen from '../components/DetailScreen';
import useTruflowData from '../hooks/useTruflowData';
import { IncomePatternCard, CashflowCard, SectionEyebrow, Spinner } from './Dashboard';

// Cash flow detail screen — the income pattern and the 90-day projection live
// together because the pattern drives the projection. Section eyebrows sit
// outside the cards (same structure as Home and Taxes); both cards render their
// own empty state rather than returning null, so neither eyebrow can orphan.
export default function CashflowScreen() {
  const navigate = useNavigate();
  const { loading, curveData, cashflowData, negativeMonthInsight } = useTruflowData();

  return (
    <DetailScreen title="Cash flow">
      {loading ? (
        <Spinner />
      ) : (
        <>
          <SectionEyebrow>Income pattern</SectionEyebrow>
          <IncomePatternCard curveData={curveData} navigate={navigate} />
          <SectionEyebrow>Next 90 days</SectionEyebrow>
          <CashflowCard cashflowData={cashflowData} negativeMonthInsight={negativeMonthInsight} navigate={navigate} />
        </>
      )}
    </DetailScreen>
  );
}
